export const CITATION_TYPE_LABELS: Record<string, string> = {
  'certificate-of-incorporation': 'COI',
};

export const ROUND_TYPE_LABELS: Record<string, string> = {
  seed: 'Seed',
  angel: 'Angel',
  series_a: 'Series A',
  series_b: 'Series B',
  series_c: 'Series C',
  series_d: 'Series D',
  series_e: 'Series E',
  series_f: 'Series F',
  series_g: 'Series G',
  series_h: 'Series H',
  growth: 'Growth',
  convertible_note: 'Convertible Note',
  debt: 'Debt',
  ipo: 'IPO',
  spac: 'SPAC',
  secondary: 'Secondary',
};

export const DEFAULT_COMPANY_SUMMARY_CURRENCY = 'USD';
export const CAP_IQ_DEFAULT_UNIT = 1_000_000;
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
